'use client'
import React from 'react';

// width = w-40 || w-52 || w-60 || w-72 || w-80 || w-96 || w-full
// options = [ {title : 'En pozo', dbValue : 'en pozo' }]
const CommonSelect = ({ name, onChange, defaultValue, title = '', required = false, testId = '', width = 'w-80', options = [] }) => {

  return (
    <label className={` ${width} flex flex-col justify-center relative`}>
      <div className='text-xs 2xl:text-sm font-semibold flex justify-between w-full'>{title}</div>
      <select
        name={name}
        className={`w-full h-12 px-2 text-xs xl:text-sm rounded border border-gray-300 focus-within:border-gray-300 focus:border-gray-300`}
        defaultValue={defaultValue}
        data-test-id={testId}
        required={required}
        onChange={onChange}
      >
        {
          options.map(({ title, dbValue }) => <option key={title} value={dbValue}>{title}</option>)
        }
      </select>
    </label>
  );
}

export default CommonSelect;
